import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import api from "../services/api";

/**
 * 出退勤管理の「スケジュール管理」リンク先（クエリ date / departmentName）
 */
const AdminScheduleHub = () => {
  const navigate = useNavigate();
  const [search] = useSearchParams();
  const date = search.get("date") || "";
  const departmentName = search.get("departmentName") || "";
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError("");
    const params = {};
    if (date) params.date = date;
    if (departmentName) params.departmentName = departmentName;
    api
      .get("/api/worktime/admin/unregistered-schedule-list/", { params })
      .then((res) => {
        if (!cancelled) {
          const emps = res.data?.employees;
          setList(Array.isArray(emps) ? emps : []);
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.response?.data?.message || "一覧の取得に失敗しました。");
          setList([]);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [date, departmentName]);

  return (
    <div style={{ padding: 24, maxWidth: 960 }}>
      <Link to="/admin/workstime" style={{ color: "#2563eb" }}>
        ← 出退勤管理に戻る
      </Link>
      <h2 style={{ marginTop: 16 }}>スケジュール管理</h2>
      {(date || departmentName) && (
        <p style={{ color: "#64748b" }}>
          {date && <>参照日: {date} </>}
          {departmentName && <>／ 部署: {departmentName}</>}
        </p>
      )}

      <div style={{ marginTop: 20 }}>
        <Link to="/admin/shift-bulk-import" style={{ fontWeight: 600 }}>
          全員スケジュール一括取込（CSV）
        </Link>
        <Link to="/admin/shift-roster-import" style={{ fontWeight: 600, marginLeft: 24 }}>
          全員スケジュール一括取込（Excel）
        </Link>
      </div>

      <h3 style={{ marginTop: 28, fontSize: "1.1rem" }}>スケジュール未登録社員</h3>
      {loading && <p style={{ color: "#64748b" }}>読み込み中…</p>}
      {error && <p style={{ color: "#b91c1c" }}>{error}</p>}
      {!loading && !error && (
        <>
          <p style={{ color: "#64748b", fontSize: "0.95rem" }}>
            {list.length === 0
              ? "未登録の社員はいません（または休日シフトのみ等）。"
              : `${list.length} 名 ／ 各行の「スケジュール確認」から、その社員の月間スケジュールを確認・登録できます。`}
          </p>
          {list.length > 0 && (
            // 未登録者が多いときも見出しが流れないよう、枠の中でスクロールさせる
            // （bugfix_管理画面テーブルレイアウト_20261005.md BUG-601）
            <div className="adm-table-scroll" style={{ marginTop: 12 }}>
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  fontSize: "0.95rem",
                }}
              >
                <thead>
                  <tr style={{ borderBottom: "2px solid #e2e8f0", textAlign: "left" }}>
                    <th style={{ padding: "8px 10px", background: "#fff" }}>社員ID</th>
                    <th style={{ padding: "8px 10px", background: "#fff" }}>氏名</th>
                    <th style={{ padding: "8px 10px", background: "#fff" }}>部署</th>
                    <th style={{ padding: "8px 10px", background: "#fff" }}>課</th>
                    <th style={{ padding: "8px 10px", background: "#fff" }}>対象日</th>
                    <th style={{ padding: "8px 10px", background: "#fff" }}>操作</th>
                  </tr>
                </thead>
                <tbody>
                  {list.map((e) => (
                    <tr
                      key={`${e.memberId}-${e.date}`}
                      style={{ borderBottom: "1px solid #f1f5f9" }}
                    >
                      <td style={{ padding: "8px 10px", fontWeight: 600 }}>{e.memberId}</td>
                      <td style={{ padding: "8px 10px" }}>{e.name}</td>
                      <td style={{ padding: "8px 10px", color: "#64748b" }}>
                        {e.departmentBuName || e.departmentName || "—"}
                      </td>
                      <td style={{ padding: "8px 10px", color: "#64748b" }}>
                        {e.kaName || "—"}
                      </td>
                      <td style={{ padding: "8px 10px" }}>{e.date || "—"}</td>
                      <td style={{ padding: "8px 10px" }}>
                        <button
                          type="button"
                          onClick={() =>
                            navigate(`/admin/employee-schedule/${e.memberId}`, {
                              state: { name: e.name },
                            })
                          }
                          style={{
                            padding: "5px 12px",
                            background: "#0099ff",
                            color: "#fff",
                            border: "none",
                            borderRadius: 5,
                            fontSize: "0.82rem",
                            fontWeight: 600,
                            cursor: "pointer",
                            whiteSpace: "nowrap",
                          }}
                        >
                          スケジュール確認
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default AdminScheduleHub;
